import { useSelector } from 'react-redux';
import { getLimitsMap } from '../selectors/authSelectors';
import get from 'transmute/get';
export const useLimit = limitKey => {
  const limitsMap = useSelector(getLimitsMap);
  return get(limitKey, limitsMap);
};